import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { font } from '../../styles';
import { styled, widgetVariantMapper } from '../../utils';
import { Card, CardContent, CardHeader } from '../Card';
import { Icon } from '../Icon';
import { Skeleton } from '../Skeleton';
import { Typography } from '../Typography';
const CardHeaderStyled = styled(CardHeader)(({ theme }) => ({
    padding: theme.spacing(2),
}));
const IconContainerStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'variant',
    name: 'IconContainer',
})(({ theme, variant }) => {
    const { iconColor } = widgetVariantMapper(variant, theme);
    return {
        backgroundColor: `${iconColor}`,
        height: font.size['4xl'],
        width: font.size['4xl'],
        borderRadius: '50%',
        border: `1px solid ${iconColor}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };
});
const IconStyled = styled(Icon)(() => ({
    color: 'white',
}));
const CardContentStyled = styled(CardContent)(({ theme }) => ({
    padding: theme.spacing(2),
    '&:last-of-type': {
        paddingBottom: theme.spacing(2),
    },
}));
export function Widget({ title, description, icon, iconSize, variant, testId, loading, }) {
    return (_jsxs(Card, { "data-name": testId, sx: (theme) => {
            const { borderColor } = widgetVariantMapper(variant, theme);
            return {
                border: `1px solid ${borderColor}`,
            };
        }, children: [_jsx(CardHeaderStyled, { title: title === null || loading ? _jsx(Skeleton, { width: 50 }) : title, titleSize: "largeTitle", action: _jsx(IconContainerStyled, { variant: variant, children: _jsx(IconStyled, { variant: icon, fontSize: iconSize ?? 'medium' }) }) }), _jsx(CardContentStyled, { children: _jsx(Typography, { variant: "body1", children: description }) })] }));
}
